<template>
  <div class="card">
    <b-card border-variant="light" class="cardDestaques">
      <b-card-header
        :header="header"
        header-text-variant="white"
        header-tag="header"
        style="background-color:rgb(55, 71, 79)"
      ></b-card-header>
      <b-card-text>
        <swiper :options="swiperOption">
          <swiper-slide v-for="destaque in destaques.destaques" :key="destaque.codigo">
            <template>
              <span class="imgGrade"><img :src="destaque.url" alt=""/></span>
              <span><strong>Item:</strong> {{destaque.codigoGrade}}</span>
              <span class="descGrade"><strong>Descrição:</strong> {{destaque.descricaoGrade}}</span>
            </template>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </b-card-text>
    </b-card>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  export default {
    props: {
      header: '',
      pCardNovidadesValues: {destaques: []}
    },
    computed: {
      ...mapState({
        cor: state => {
          const { cor } = state.cor
          return {
            'background-color': cor
          }
        }
      })
    },
    watch: {
      pCardNovidadesValues: function (newVal, oldVal) { // watch it
        this.destaques = newVal
      }
    },
    data () {
      return {
        destaques: [],
        swiperOption: {
          slidesPerView: 5,
          spaceBetween: 5,
          freeMode: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          breakpoints: {
            // 1024: {
            //   slidesPerView: 4,
            //   spaceBetween: 40
            // },
            768: {
              slidesPerView: 4,
              spaceBetween: 40
            },
            640: {
              slidesPerView: 3,
              spaceBetween: 30
            },
            500: {
              slidesPerView: 2,
              spaceBetween: 20
            }
            // ,
            // 320: {
            //   slidesPerView: 2,
            //   spaceBetween: 20
            // }
          }
        }
      }
    },
    mounted () {
      this.destaques = this.pCardNovidadesValues
    }
  }
</script>
<style scoped>
  .card-text {
    padding: 1.25rem 30px;
  }
  .card-body{
    padding: 0 !important;
  }
  .swiper-slide {
    cursor: pointer;
  }
  .cardDestaques img {
    max-width: 100%;
    max-height: 100%;
  }
  .cardDestaques span {
    display: block;
  }
  .descGrade {
    height: 50px;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/items/cardNovidadesVue.vue